import React, { useMemo } from 'react'
import WhatsappFlowPreview from './WhatsappFlowPreview'

const MAX_FLOW_FIELDS = 10
const FLOW_GROUP_TYPES = ['RadioButtonsGroup', 'CheckboxGroup']

function optionTitles(options) {
  if (Array.isArray(options)) {
    return options.map((o) => {
      if (o && typeof o === 'object') return String(o.title || o.label || o.key || '').trim()
      return String(o || '').trim()
    }).filter(Boolean)
  }
  return String(options || '').split('|').map(s => s.trim()).filter(Boolean)
}

function buildFlowScreensFromFormData(formData) {
  const fd = formData || {}
  const children = []
  for (let n = 1; n <= MAX_FLOW_FIELDS; n += 1) {
    const type = fd[`field${n}Type`]
    if (!type || type === 'NONE') break
    const node = {
      type,
      name: `field_${n}`,
      label: String(fd[`field${n}Label`] || '').trim(),
      required: fd[`field${n}Required`] === 'YES',
    }
    if (FLOW_GROUP_TYPES.includes(type)) {
      node['data-source'] = optionTitles(fd[`field${n}Options`]).map((title, idx) => ({
        id: `opt_${n}_${idx + 1}`,
        title,
      }))
    }
    children.push(node)
  }
  children.push({
    type: 'Footer',
    label: String(fd.footerButtonLabel || '').trim(),
  })
  return [{
    title: String(fd.screenTitle || '').trim(),
    layout: {
      type: 'SingleColumnLayout',
      children: [{
        type: 'Form',
        name: 'form',
        children,
      }],
    },
  }]
}

export default function WhatsappFlowPreviewAdapter({ formData }) {
  const flowScreens = useMemo(
    () => buildFlowScreensFromFormData(formData),
    [formData]
  )
  return <WhatsappFlowPreview flowScreens={flowScreens} />
}
